import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Button, Form, OverlayTrigger, Popover } from "react-bootstrap";
import { Link } from "react-router-dom";
import BackButton from "../BackButton";
import NextButton from "../NextButton";
import SkipButton from "../SkipButton";
import getNextPage from "../getNextPage";
import CustomFormCheck from "utils/CustomFormCheck";
import jsDig from "utils/jsDig";
import { RouterContext } from "../Onboarding";

export default function ShopifyAccess(props) {
  const route = useContext(RouterContext);

  const nextPage = getNextPage(props.onboarding_progress);

  useEffect(() => {
    window.localStorage.setItem("routerHistory", JSON.stringify([...route.get]));
  }, [route.get]);

  props.pageLocator();

  const [validated, setValidated] = useState(false);
  const [radio, setRadio] = useState(false)

  useEffect(() => {
    const form = document.getElementById("onboarding-form");
    if ((form.checkValidity() === true) && (radio === true)) {
      setValidated(true);
    } else {
      setValidated(false);
    }
  });

  const [accessGranted, setAccessGranted] = useState(
    jsDig(["Shopify", "Restricted"], props.teamAccess) == "1" || jsDig(["Shopify", "Full"], props.teamAccess) == "1"
  );
  const [urlProvided, setUrlProvided] = useState(false);

  let shopifyIcon = require("images/logos/shopify-icon.png");
  shopifyIcon = <img className="shopify-icon" style={{ width: "15px", position: "relative", top: "-2px", left: "5px" }} src={`/datapulse${shopifyIcon}`} />;

  return (
    <>
      <Row className=" px-4 mb-3 pb-3 justify-content-center">
        <Col xl={7} lg={10}>
          <div>
            <p className="pb-3 f28 visby-bold primary text-center">Grant Shopify Access</p>
          </div>
          <div>
            <p className=" f14 nunito-regular primary text-left">
              On this page you will grant access to Shopify, which requires a unique process to grant access. There are three steps below that include providing
              the client store URL, having access requested, and then the client granting said access.
            </p>
          </div>
        </Col>
      </Row>
      <Row className="my-5 justify-content-center">
        <Col xl={5} lg={7} style={{ maxWidth: "100%" }}>
          <Row>
            <Col>
              <p className="visby-bold pb-2 light-primary f16 text-left">First, enter your Shopify store URL:</p>
            </Col>
          </Row>

          <Row className="align-items-center pb-1">
            <Col className="d-flex flex-wrap">
              <Form.Control
                size="md"
                style={{ width: "235px" }}
                name="shopify_url"
                value={props.shopifyUrl}
                onChange={(e) => props.setShopifyUrl(e.target.value)}
                required
                type="text"
              />
              <p className="f16 nunito-regular light-primary text-left" style={{ paddingTop: "5px", paddingLeft: "6px" }}>
                <strong>.myshopify.com</strong>
              </p>
            </Col>
          </Row>
          <Row>
            <Col>
              <div style={{ marginTop: "14px" }}>
                <p className="f14 light-primary text-left">
                  Next you will need to grant {route.organization.name} access to the account. Check the boxes below to confirm they've been completed.
                </p>
              </div>
              <div style={{ marginTop: "14px" }}>
                <p className="f14 light-primary text-left">Complete as many of the below steps as possible, and check to confirm.</p>
              </div>
              <div className="grey-box" style={{ backgroundColor: "#E1E1E1", marginTop: "14px" }}>
                <div className="pb-2 text-left">
                  <CustomFormCheck
                    id="ob-store-url-provided"
                    required
                    name="store-url-provided"
                    label="Store URL provided above and checked as correct."
                    checked={urlProvided}
                    onChange={(e) => setUrlProvided(!urlProvided)}
                  />
                </div>
                <div className="pb-2 text-left">
                  <CustomFormCheck
                    id="ob-shopify-access-requested"
                    required
                    name="shopify-requested"
                    label={`Access has been requested by ${route.organization.name}.`}
                    dynamic
                    checked={accessGranted}
                    onChange={(e) => {
                      let accessChecked = props.teamAccess;
                      accessChecked["Shopify"]["Requested"] = props.teamAccess["Shopify"]["Requested"] == "1" ? "0" : "1";
                      props.setTeamAccess({ ...accessChecked });
                    }}
                  />
                </div>
                <div className="pb-2 text-left">
                  <CustomFormCheck
                    id="ob-shopify-approved"
                    required
                    name="shopify-approved"
                    label="Access has been approved by client."
                    dynamic
                    checked={jsDig(["Shopify", "Full"], props.teamAccess) == "1"}
                    onChange={(e) => {
                      let accessChecked = props.teamAccess;
                      accessChecked["Shopify"]["Full"] = "1";
                      props.setTeamAccess({ ...accessChecked });
                    }}
                  />

                  <input hidden name="current_onboarding_page" value={window.location.href} readOnly />
                </div>
                <div className="pl-3">
                <p className="f14 light-primary text-left">
                Will Shopify data be pulled utilizing all sales channels or only the online store?
                </p>
              </div>
                <div className="pb-2 pt-2 pl-4 text-left">
                <Form.Check
                className="radio"
                  name="shopify_revenue_type"
                  value="online_store"
                  custom
                  label="Online Store Sales Only"
                  type="radio"
                  id="shopify_revenue_type_0"
                  defaultChecked={false}
                  onClick={()=> {props.setShopifyChannel("online_store");
                                  setRadio(true)}}
                />
                <Form.Check
                  name="shopify_revenue_type"
                  value="overall"
                  custom
                  label="All Sales Channels"
                  type="radio"
                  id="shopify_revenue_type_1"
                  defaultChecked={false}
                  onClick={()=> {props.setShopifyChannel("overall");
                                setRadio(true)}}
                />
                </div>
              </div>
            </Col>
          </Row>
        </Col>
        {/* <Col lg={5} className="mt-3">
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/rbm6-CvsYaE"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{ maxWidth: "100%" }}></iframe>
        </Col> */}
      </Row>

      <Row className="pt-3 justify-content-center">
        <Col>
          <div className="navButtonRow">
            <BackButton />
            <SkipButton btnText={`Skip for now`} nextPage={nextPage.url} />
            <NextButton
              validated={validated}
              btnText={`Next`}
              nextPage={nextPage.url}
              invalidText={`We need more information on this page before you continue.`}
              submitForm={props.submitForm}
            />
          </div>
        </Col>
      </Row>
    </>
  );
}
